import { useEffect } from "react";

import { useTypedQuery } from "hooks";
import { useGetUnlinkedLicensesFilters } from "modules/UnlinkedExactLicensesDashboard/components/UnlinkedExactLicensesFilters/hooks";
import { UnlinkedExactLicensesQueryKeys } from "modules/UnlinkedExactLicensesDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useUnlinkedLicensesQuery = () => {
  const filters = useGetUnlinkedLicensesFilters();

  const query = useTypedQuery({
    queryKey: UnlinkedExactLicensesQueryKeys.unlinkedExactCategories,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { ...filters }, baseUrl)).data.exact_categories
  });

  useEffect(() => {
    query.refetch();
  }, [filters]);

  return query;
};
